import {AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {StyledActivityReportWarningBanner} from './style'

type ActivityReportValidationBannerProps = {
    accessesToValidate: number
    absencesToValidate: number
}

export const ActivityReportValidationBanner = ({
    accessesToValidate,
    absencesToValidate
}: ActivityReportValidationBannerProps) => {
    const {t} = useTranslation()

    return (
        <StyledActivityReportWarningBanner>
            <div className="banner-header">
                <AlertTriangleIcon size={16} />
                {t('activity_report:validation_banner_title')}
            </div>
            <span>
                {t('activity_report:validation_banner_description', {
                    accesses: accessesToValidate,
                    absences: absencesToValidate
                })}
            </span>
        </StyledActivityReportWarningBanner>
    )
}
